/* eslint-disable import/prefer-default-export */

import {
  EDIT_TASK__GET_TASK,
  EDIT_TASK__GET_TASK_SUCCESS,
  EDIT_TASK__GET_TASK_FAIL,
  SET_TASK,
  SET_TASK_START_LOADING,
  SET_TASK_STOP_LOADING,
  RESET_TASK,
} from '../constants';
import { buildQuery } from '../helpers';

export function getTask(id, params = {}) {
  return {
    types: [
      EDIT_TASK__GET_TASK,
      EDIT_TASK__GET_TASK_SUCCESS,
      EDIT_TASK__GET_TASK_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/tasks/${id}?${buildQuery(params)}`, {
        method: 'GET',
      }),
  };
}

export function getTaskWithCertificate(id, params) {
  return {
    types: [
      EDIT_TASK__GET_TASK,
      EDIT_TASK__GET_TASK_SUCCESS,
      EDIT_TASK__GET_TASK_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/tasks/${id}/with-certificate?${buildQuery(params)}`, {
        method: 'GET',
      }),
  };
}

export function setTask(task) {
  return async dispatch => {
    await dispatch({
      type: SET_TASK_START_LOADING,
    });
    await dispatch({
      type: SET_TASK,
      task,
    });
    await dispatch({
      type: SET_TASK_STOP_LOADING,
    });
  };
}

export function reset() {
  return {
    type: RESET_TASK,
  };
}
